export const SITE_NAME: string = 'Martin Huang';
export const LINKEDIN_URL: string = 'https://www.linkedin.com/in/martin-huang-7ab236175/';
export const GITHUB_URL: string = 'https://github.com/mhuangcode';
export enum Colors {
    Primary = '#3f4b3b',
    Secondary = '#729b79',
    White = '#fafafa',
}